import AOS from 'aos'

export default class Animation {
   constructor() {
      this.init()
   }

   init() {
      AOS.init({
         throttleDelay: 100,
         duration: 500,
         offset: 50,
         once: true,
         easing: 'ease-out',
         disable: 'mobile',
      })
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/animation.js
// module id = 7
// module chunks = 0